var path = '/app/components/dialogs/matemagico/matemagico.html';
var html = "<div class=dialog-area> <img ng-src=\"{{ $ctrl.magicoSprite }}\"> <div class=text-box> <p class=\"dialog-text {{$ctrl.class}}\" ng-bind-html=$ctrl.currentText></p> <div class=btn-box> <div class=\"arrow left\" ng-click=$ctrl.changeStep(-1) ng-class=\"$ctrl.step===0 ? 'dstv' : ''\"></div> <div class=\"arrow right\" ng-click=$ctrl.changeStep(1)></div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/matemagico/matemagico.html
// module id = 138
// module chunks = 0